import React from "react"
import "./LandingPage.css"

export default function PrivacyPolicy() {
  return (
    <div className="lp-shell">
      <div className="lp-legal">
        <h1>Privacy Policy</h1>
        <p>Last updated: April 30, 2026</p>

        <h2>1. Overview</h2>
        <p>AgentColab is self-hosted software. This means all data is stored and processed on your own infrastructure. We do not collect, transmit, or have access to your data.</p>

        <h2>2. Data We Do Not Collect</h2>
        <ul>
          <li>Agent conversations or configurations</li>
          <li>Credentials, API keys, or secrets</li>
          <li>Messaging channel content or metadata</li>
          <li>Usage analytics or telemetry</li>
          <li>Personal information from your installation</li>
        </ul>

        <h2>3. Website Data</h2>
        <p>When you visit agentcolab.io, standard web server logs may be generated (IP address, browser type, page requested). These logs are used solely for security and performance monitoring and are not shared with third parties.</p>

        <h2>4. Download Tokens</h2>
        <p>If you register for an account on our website, we store your email address and a hashed password. This information is used solely to provide download access and is never sold or shared.</p>

        <h2>5. Third-Party Services</h2>
        <p>AgentColab integrates with third-party AI model providers (OpenRouter, OpenAI, Ollama) and messaging platforms (Discord, Slack, Telegram, WhatsApp). These services have their own privacy policies. We do not control their data practices.</p>

        <h2>6. Data Security</h2>
        <p>You are responsible for securing your AgentColab installation. The Software provides encrypted credential storage (Fernet) and JWT-based authentication. We recommend keeping your installation updated and following security best practices.</p>

        <h2>7. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Changes will be reflected on this page with an updated revision date.</p>

        <h2>8. Contact</h2>
        <p>For privacy-related questions, contact support@agentcolab.io.</p>
      </div>
    </div>
  )
}
